//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "HIS",
  data() {
    return {
      form: {
        diabetes: "0",
        hypertension: "0",
        ageOver60: "0",
        clinic: "0",
        duration: "0",
        dual: "0",
        stenosis: "0",
        mri: "0",
        history:'0',
        apoplexy:'0',
        arteriosclerosis:'0',
        neurological:'0',
        neurologicalQuel:'0'
      },
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      console.log(form,'form1');
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      console.log(form,'form');
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        // diabetes + hypertension + ageOver60 + clinic + duration  + (dual ? 2 : 0) + (mri ? 2 : 0) + (stenosis ? 2 : 0)
        let result =
          (form.diabetes ? form.diabetes * 2 : 0) +
          form.hypertension +
          (form.ageOver60 ?form.ageOver60*2 :0 ) +
          form.clinic +
          form.duration +
          form.dual +
          form.mri +
          form.stenosis +
          form.history +
          (form.apoplexy ? form.apoplexy*2 :0) +
          form.arteriosclerosis +
          (form.neurological ? form.neurological*2:0)
          +
          (form.neurologicalQuel ? form.neurologicalQuel*2:0)
          
          ;

        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/HIS.vue